'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = StripeSecurityCallout;

require('./stripe-security-callout.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _secure_badge_2x = require('./assets/secure_badge_@2x.png');

var _secure_badge_2x2 = _interopRequireDefault(_secure_badge_2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function StripeSecurityCallout(p) {

    var text = 'All payments made on HelloSign are 100% secure.';

    return _react2['default'].createElement(
        'div',
        { className: 'stripe-security-callout' },
        _react2['default'].createElement('img', { src: _secure_badge_2x2['default'] }),
        _react2['default'].createElement(
            'small',
            null,
            ' ',
            text,
            ' '
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/stripe-security-callout.jsx
 ** module id = 1096
 ** module chunks = 0
 **/